import { PdaSectionActsComponent } from "../components/sections/pda-section-acts/pda-section-acts.component";
import { NomiDescrittoriSezione } from "src/app/common/configuration/nomi-descrittori-sezione";
import { Configuration, ConfigurationFeature } from "src/app/common/configuration/models/configuration";
import { PdaLoginIconComponent } from "../components/pda-login-icon/pda-login-icon.component";
import { PdaSectionGeneralDataComponent } from "../components/sections/pda-section-general-data/pda-section-general-data.component";
import { PdaSectionPartyComponent } from "../components/sections/pda-section-party/pda-section-party.component";
import { PdaSectionSchedulesComponent } from "../components/sections/pda-section-schedules/pda-section-schedules.component";
import { PctSidebarLinkComponent } from "../components/pct-sidebar-link/pct-sidebar-link.component";

export const pdaConfiguration = [
    {
        context: NomiDescrittoriSezione.SEZIONE_ATTI_FASCICOLO,
        feature: ConfigurationFeature.JUSTICE_PDA,
        component: PdaSectionActsComponent,
        enabled: false,
        properties: {}
    },
    {
        context: "USER",
        feature: ConfigurationFeature.JUSTICE_PDA,
        component: PdaLoginIconComponent,
        enabled: false,
        properties: {}
    },
    {
        context: NomiDescrittoriSezione.SEZIONE_DATI_GENERALI_FASCICOLO,
        feature: ConfigurationFeature.JUSTICE_PDA,
        component: PdaSectionGeneralDataComponent,
        enabled: false,
        properties: {}
    },
    {
        context: NomiDescrittoriSezione.SEZIONE_CONTROPARTI_FASCICOLO,
        feature: ConfigurationFeature.JUSTICE_PDA,
        component: PdaSectionPartyComponent,
        enabled: false,
        properties: {}
    },
    {
        context: NomiDescrittoriSezione.SEZIONE_SCADENZARIO_FASCICOLO,
        feature: ConfigurationFeature.JUSTICE_PDA,
        component: PdaSectionSchedulesComponent,
        enabled: false,
        properties: {}
    },
    {
        context: NomiDescrittoriSezione.DESCRITTORE_CANCELLERIA_TELEMATICA,
        feature: ConfigurationFeature.JUSTICE_PDA,
        component: PctSidebarLinkComponent,
        enabled: false,
        properties: {}
    },
    {
        context: NomiDescrittoriSezione.DESCRITTORE_CANCELLERIA_EVENTI,
        feature: ConfigurationFeature.JUSTICE_PDA,
        // component: PctSidebarLinkComponent,
        enabled: false,
        properties: {}
    }
] as Configuration[];

export class PdaConfiguration {
    pdaBaseUrl: string;
    pdaAuthUrl: string;
}